import { Song, Artist, Store, Analytics, User } from '../types';

export const mockUser: User = {
  id: '1',
  name: 'Utsav GC',
  email: 'alex@naadindia.com',
  avatar: '/1080.png',
  plan: 'pro',
  joinedDate: '2023-01-15',
  totalSongs: 247,
  totalRevenue: 789.64
};

export const mockArtists: Artist[] = [
  {
    id: '1',
    name: 'Arjun Kanungo',
    bio: 'Indian playback singer, composer and performer known for his soulful voice and contemporary style.',
    image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&h=400&fit=crop&crop=face',
    socialLinks: {
      instagram: '@arjunkanungo',
      twitter: '@arjunkanungo_',
      spotify: 'arjun-kanungo',
      youtube: 'ArjunKanungoOfficial'
    },
    contactInfo: {
      email: 'arjun@naadindia.com',
      phone: '+91-9876543210'
    },
    totalSongs: 45,
    totalStreams: 98000,
    totalRevenue: 544.34,
    joinedDate: '2023-02-10'
  },
  {
    id: '2',
    name: 'Priya Saraiya',
    bio: 'Versatile singer and songwriter specializing in Indian classical fusion and contemporary pop.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616c4d26c97?w=400&h=400&fit=crop&crop=face',
    socialLinks: {
      instagram: '@priyasaraiya',
      spotify: 'priya-saraiya',
      youtube: 'PriyaSaraiyaMusic'
    },
    contactInfo: {
      email: 'priya@naadindia.com'
    },
    totalSongs: 32,
    totalStreams: 41000,
    totalRevenue: 245.30,
    joinedDate: '2023-03-20'
  },
  {
    id: '3',
    name: 'The Mumbai Collective',
    bio: 'An indie band creating experimental fusion music blending traditional Indian instruments with modern production.',
    image: 'https://images.unsplash.com/photo-1516280440614-37939bbacd81?w=400&h=400&fit=crop',
    socialLinks: {
      instagram: '@mumbai_collective',
      facebook: 'TheMumbaiCollective',
      spotify: 'the-mumbai-collective'
    },
    contactInfo: {
      email: 'band@mumbai-collective.com'
    },
    totalSongs: 28,
    totalStreams: 0,
    totalRevenue: 0.00,
    joinedDate: '2023-04-15'
  }
];

export const mockSongs: Song[] = [
  {
    id: '1',
    title: 'Midnight Dreams',
    artist: 'Arjun Kanungo',
    artistId: '1',
    coverArt: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&h=400&fit=crop',
    status: 'live',
    stores: ['spotify', 'apple-music', 'youtube-music', 'amazon-music', 'jiosaavn'],
    uploadDate: '2024-01-15',
    releaseDate: '2024-01-20',
    genre: 'Pop',
    duration: 234000,
    streams: 58000,
    revenue: 320.15,
    isrc: 'IN-NMG-24-00001',
    producer: 'Rohit Sharma',
    copyright: '2024 Naad Music Group'
  },
  {
    id: '2',
    title: 'Ocean Waves',
    artist: 'Priya Saraiya',
    artistId: '2',
    coverArt: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=400&h=400&fit=crop',
    status: 'live',
    stores: ['spotify', 'apple-music', 'deezer', 'tidal', 'gaana'],
    uploadDate: '2024-01-10',
    releaseDate: '2024-01-18',
    genre: 'Classical Fusion',
    duration: 298000,
    streams: 41000,
    revenue: 245.30,
    isrc: 'IN-NMG-24-00002',
    featuredArtists: ['Ravi Shankar Jr.'],
    copyright: '2024 Naad Music Group'
  },
  {
    id: '3',
    title: 'City Lights',
    artist: 'The Mumbai Collective',
    artistId: '3',
    coverArt: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=400&h=400&fit=crop',
    status: 'pending',
    stores: ['spotify', 'apple-music', 'youtube-music'],
    uploadDate: '2024-01-22',
    releaseDate: '2024-01-30',
    genre: 'Indie Rock',
    duration: 267000,
    streams: 0,
    revenue: 0,
    isrc: 'IN-NMG-24-00003',
    copyright: '2024 Naad Music Group'
  },
  {
    id: '4',
    title: 'Bollywood Nights',
    artist: 'Arjun Kanungo',
    artistId: '1',
    coverArt: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&h=400&fit=crop',
    status: 'live',
    stores: ['spotify', 'apple-music', 'jiosaavn', 'gaana', 'wynk'],
    uploadDate: '2024-01-05',
    releaseDate: '2024-01-12',
    genre: 'Bollywood',
    duration: 245000,
    streams: 40000,
    revenue: 224.19,
    isrc: 'IN-NMG-24-00004',
    copyright: '2024 Naad Music Group'
  },
  {
    id: '5',
    title: 'Serenity',
    artist: 'Priya Saraiya',
    artistId: '2',
    coverArt: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=400&h=400&fit=crop',
    status: 'failed',
    stores: [],
    uploadDate: '2024-01-20',
    releaseDate: '2024-01-25',
    genre: 'Ambient',
    duration: 342000,
    streams: 0,
    revenue: 0,
    copyright: '2024 Naad Music Group'
  }
];

export const mockStores: Store[] = [
  // Major Streaming Platforms
  { id: 'spotify', name: 'Spotify', logo: '🎵', category: 'streaming', region: ['Global'], processingTime: '1-2 days', isActive: true, description: 'World\'s largest music streaming platform' },
  { id: 'apple-music', name: 'Apple Music', logo: '🍎', category: 'streaming', region: ['Global'], processingTime: '1-3 days', isActive: true, description: 'Apple\'s premium music streaming service' },
  { id: 'youtube-music', name: 'YouTube Music', logo: '📺', category: 'streaming', region: ['Global'], processingTime: '1-2 days', isActive: true, description: 'Google\'s music streaming platform' },
  { id: 'amazon-music', name: 'Amazon Music', logo: '📦', category: 'streaming', region: ['Global'], processingTime: '2-5 days', isActive: true, description: 'Amazon\'s music streaming service' },
  { id: 'deezer', name: 'Deezer', logo: '🎶', category: 'streaming', region: ['Global'], processingTime: '1-3 days', isActive: true, description: 'French music streaming service' },
  { id: 'tidal', name: 'Tidal', logo: '🌊', category: 'streaming', region: ['Global'], processingTime: '2-7 days', isActive: true, description: 'High-fidelity music streaming' },
  
  // Indian Platforms
  { id: 'jiosaavn', name: 'JioSaavn', logo: '🇮🇳', category: 'streaming', region: ['India', 'South Asia'], processingTime: '1-2 days', isActive: true, description: 'India\'s leading music streaming platform' },
  { id: 'gaana', name: 'Gaana', logo: '🎵', category: 'streaming', region: ['India'], processingTime: '2-3 days', isActive: true, description: 'Popular Indian music streaming service' },
  { id: 'wynk', name: 'Wynk Music', logo: '📱', category: 'streaming', region: ['India'], processingTime: '1-3 days', isActive: true, description: 'Airtel\'s music streaming platform' },
  { id: 'hungama', name: 'Hungama Music', logo: '🎭', category: 'streaming', region: ['India'], processingTime: '3-5 days', isActive: true, description: 'Indian digital entertainment platform' },
  
  // Social Media
  { id: 'instagram', name: 'Instagram/Facebook', logo: '📸', category: 'social', region: ['Global'], processingTime: '1-7 days', isActive: true, description: 'Meta\'s social media platforms' },
  { id: 'tiktok', name: 'TikTok', logo: '🎬', category: 'social', region: ['Global'], processingTime: '3-7 days', isActive: true, description: 'Short-form video platform' },
  { id: 'youtube-content-id', name: 'YouTube Content ID', logo: '🛡️', category: 'social', region: ['Global'], processingTime: '5-10 days', isActive: true, description: 'YouTube\'s copyright protection system' },
  
  // Download Stores
  { id: 'itunes', name: 'iTunes Store', logo: '💿', category: 'download', region: ['Global'], processingTime: '3-7 days', isActive: true, description: 'Apple\'s digital music store' },
  { id: 'google-play', name: 'Google Play Music', logo: '🎵', category: 'download', region: ['Global'], processingTime: '2-5 days', isActive: false, description: 'Google\'s music store (discontinued)' },
  { id: 'amazon-mp3', name: 'Amazon MP3', logo: '🛒', category: 'download', region: ['Global'], processingTime: '3-7 days', isActive: true, description: 'Amazon\'s digital music store' },
  
  // International Platforms
  { id: 'anghami', name: 'Anghami', logo: '🎵', category: 'streaming', region: ['Middle East', 'North Africa'], processingTime: '2-5 days', isActive: true, description: 'Leading MENA music platform' },
  { id: 'boomplay', name: 'Boomplay', logo: '🎵', category: 'streaming', region: ['Africa'], processingTime: '3-7 days', isActive: true, description: 'Africa\'s largest music platform' },
  { id: 'qq-music', name: 'QQ Music', logo: '🇨🇳', category: 'streaming', region: ['China'], processingTime: '5-14 days', isActive: true, description: 'Tencent\'s music streaming service' },
  { id: 'netease', name: 'NetEase Cloud Music', logo: '☁️', category: 'streaming', region: ['China'], processingTime: '7-14 days', isActive: true, description: 'Popular Chinese music platform' },
  
  // Specialized Platforms
  { id: 'beatport', name: 'Beatport', logo: '🎧', category: 'download', region: ['Global'], processingTime: '3-7 days', isActive: true, description: 'Electronic music store' },
  { id: 'bandcamp', name: 'Bandcamp', logo: '🎪', category: 'download', region: ['Global'], processingTime: '1-3 days', isActive: true, description: 'Independent artist platform' },
  { id: 'soundcloud', name: 'SoundCloud', logo: '☁️', category: 'streaming', region: ['Global'], processingTime: '1-2 days', isActive: true, description: 'Audio distribution platform' },
  { id: 'audiomack', name: 'Audiomack', logo: '🎵', category: 'streaming', region: ['Global'], processingTime: '1-3 days', isActive: true, description: 'Music discovery platform' }
];

// Generate additional stores to reach exactly 478 total stores
// mockStores has 24 stores, so we need 454 more stores (478 - 24 = 454)
const storeNames = [
  '7Digital', 'HDTracks', 'Qobuz', 'Yandex Music', 'VK Music', 'Zvooq', 'Pandora', 'Shazam',
  'Microsoft Groove', 'Traxsource', 'Juno Download', 'Peloton', 'ClassPass', 'Twitch Music',
  'Snapchat', 'Twitter', 'KKBox', 'LINE Music', 'AWA', 'Rakuten Music', 'Mora', 'Recochoku',
  'Melon', 'Genie Music', 'Bugs Music', 'Vibe', 'FLO', 'VKontakte', 'Odnoklassniki',
  'Mail.ru Music', 'Zvuk', 'Boom Music', 'MegaFon Music', 'Beeline Music', 'Tele2 Music',
  'SoundHound', 'Mixcloud', 'Reverbnation', 'CD Baby', 'DistroKid Pro', 'TuneCore Global',
  'Amuse Pro', 'LANDR Distribution', 'Symphonic Distribution', 'The Orchard', 'AWAL Music',
  'Kobalt Music', 'Empire Distribution', 'InGrooves Music', 'Caroline Distribution', 'STEM Music',
  'Believe Digital', 'BMG Rights', 'Warner Music', 'Sony Music', 'Universal Music',
  'EMI Music', 'Atlantic Records', 'Capitol Records', 'RCA Records', 'Columbia Records',
  'Def Jam', 'Interscope', 'Republic Records', 'Island Records', 'Epic Records',
  'Arista Records', 'Geffen Records', 'MCA Records', 'Elektra Records', 'Asylum Records',
  'Virgin Records', 'Parlophone', 'Rough Trade', 'Sub Pop', 'Domino Records',
  'XL Recordings', 'Warp Records', 'Ninja Tune', 'Ghostly International', 'Brainfeeder',
  'Flying Lotus', 'Stones Throw', 'Rhymesayers', 'Strange Music', 'Tech N9ne',
  'Hopeless Records', 'Rise Records', 'Epitaph Records', 'Fat Wreck Chords', 'Dischord',
  'SST Records', 'Touch and Go', 'Matador Records', 'Merge Records', 'Kill Rock Stars',
  'Thrill Jockey', 'Drag City', 'Constellation', 'Kranky', 'Type Records',
  'Planet Mu', 'Rephlex', 'Aphex Twin', 'Skrillex', 'OWSLA',
  'Mad Decent', 'Fool\'s Gold', 'Dirtybird', 'Anjunabeats', 'Armada Music',
  'Spinnin\' Records', 'Revealed Recordings', 'Protocol Recordings', 'Size Records', 'Axtone',
  'Swedish House Mafia', 'Defected Records', 'Toolroom Records', 'Hot Creations', 'Crosstown Rebels'
];

// Generate exactly 454 additional stores
const additionalStoreNames = [];
for (let i = 0; i < 454; i++) {
  if (i < storeNames.length) {
    additionalStoreNames.push(storeNames[i]);
  } else {
    // Generate additional platform names
    const categories = ['Music', 'Stream', 'Audio', 'Sound', 'Beat', 'Tune', 'Play', 'Listen', 'Radio', 'Digital'];
    const suffixes = ['FM', 'Hub', 'Zone', 'Pro', 'Plus', 'Max', 'Live', 'Net', 'World', 'Global'];
    const category = categories[i % categories.length];
    const suffix = suffixes[(i * 3) % suffixes.length];
    const number = Math.floor(i / 10) + 1;
    additionalStoreNames.push(`${category}${suffix}${number > 1 ? number : ''}`);
  }
}

const additionalStores = additionalStoreNames.map((name, index) => ({
  id: `store-${index + 25}`,
  name,
  logo: '🎵',
  category: index % 3 === 0 ? 'streaming' : 'download' as 'streaming' | 'download',
  region: ['Global'],
  processingTime: `${Math.floor(index % 7) + 1}-${Math.floor(index % 7) + 3} days`,
  isActive: index % 10 !== 0, // 90% active
  description: `Music platform serving ${name} users globally`
}));

export const allStores = [...mockStores, ...additionalStores];

export const mockAnalytics: Analytics[] = [
  {
    date: '2024-01-25',
    streams: 125000,
    revenue: 625.50,
    downloads: 850,
    topSongs: [
      { id: '4', title: 'Bollywood Nights', streams: 45000 },
      { id: '1', title: 'Midnight Dreams', streams: 35000 },
      { id: '2', title: 'Ocean Waves', streams: 28000 }
    ],
    topStores: [
      { id: 'spotify', name: 'Spotify', streams: 65000 },
      { id: 'jiosaavn', name: 'JioSaavn', streams: 32000 },
      { id: 'apple-music', name: 'Apple Music', streams: 18000 }
    ],
    geographicData: [
      { country: 'India', streams: 75000, revenue: 375.25 },
      { country: 'United States', streams: 25000, revenue: 125.10 },
      { country: 'United Kingdom', streams: 15000, revenue: 75.15 },
      { country: 'Canada', streams: 10000, revenue: 50.00 }
    ]
  }
];

export const genres = [
  'Pop', 'Rock', 'Hip Hop', 'Electronic', 'Classical', 'Jazz', 'Blues', 'Country',
  'Folk', 'Reggae', 'Bollywood', 'Classical Fusion', 'Indie Rock', 'Ambient',
  'World Music', 'Alternative', 'R&B', 'Soul', 'Funk', 'Disco', 'House', 'Techno'
];